module.exports = __webpack_public_path__ + "static/s-exam8-ffca215fae6a5148489282075b8fdeb8.png";